const print = (text: string, text1?: any) => {
  if (text1) {
    console.info(text + text1);
  } else {
    console.info(text);
  }
};

const printError = (text: string, text1?: any) => {
  if (text1) {
    console.error(text + text1);
  } else {
    console.error(text);
  }
};

export const logger = {
  info: print,
  error: printError,
};
